import { createSelector } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';
import { SETTINGS_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin, createLoadParameterReducer, createOperationStateReducer,
} from '../../utils/getCrudConfig';
import { LOAD_SETTINGS_BY_ID, LOAD_SETTINGS_ENUM_LIMITED, LOAD_SETTINGS_LIST } from './actions';
import { CREATE, UPDATE } from '../../configs/actionNames';

const initialState = {
  settingsList: [],
  settingsListMeta: {},
  loadingSettingsList: false,
  setting: {},
  loadingSetting: false,
  loadingSettingEnum: false,
  settingEnum: [],
  loadingCreateSettings: false,
  loadingUpdateSettings: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(SETTINGS_MODULE + LOAD_SETTINGS_LIST, 'settingsList', 'loadingSettingsList'),
  ...createLoadParameterReducer(SETTINGS_MODULE + LOAD_SETTINGS_BY_ID, 'setting', 'loadingSetting'),
  ...createOperationStateReducer(SETTINGS_MODULE + CREATE, 'loadingCreateSettings'),
  ...createOperationStateReducer(SETTINGS_MODULE + UPDATE, 'loadingUpdateSettings'),
  ...createLoadParameterReducer(SETTINGS_MODULE + LOAD_SETTINGS_ENUM_LIMITED, 'settingEnum', 'loadingSettingEnum'),
}, initialState);

export default reducer;

export const getSettingsData = createSelector(
  [state => state[SETTINGS_MODULE]],
  state => {
    const {
      settingsList,
      loadingSettingsList,
      settingsListMeta,
      setting,
      loadingSetting,
      loadingSettingEnum,
      settingEnum,
      loadingCreateSettings,
      loadingUpdateSettings,
    } = state;

    return {
      loadingCreateSettings,
      loadingUpdateSettings,
      settingsList,
      loadingSettingsList,
      settingsListMeta,
      setting,
      loadingSetting,
      loadingSettingEnum,
      settingEnum,
    };
  },
);
